module.exports = __webpack_public_path__ + "static/img/jiqi-txt2.dc95387.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt2.png
// module id = JygU
// module chunks = 0